export enum StorageKeys {
  ADMINUSER = 'au',
}

export interface StorageModel {
  data: any
  expireDate: string | null
}
